<template>
  <div>
    <form
      v-for="traffic in traffics"
      :key="traffic.transportationExpenseId"
      class="traffic"
    >
      <div class="">
        <div class="form-group">
          <label>University/Campus</label>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <div><SelectCampusInput class="w-25" v-model="traffic.campus" /></div>
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <label>Transportation Cost (One-Way)</label>
          <ValidationProvider rules="required|integer|max_fee:99999" v-slot="{ errors }">
            <input
              type="text"
              class="w-25 form-control"
              v-model="traffic.fee"
            >
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <label>Commuting Time (minutes)</label>
          <ValidationProvider rules="required|integer|max_time:999" v-slot="{ errors }">
            <input
              type="text"
              class="w-25 form-control"
              v-model="traffic.commutingTime"
            >
            <div class="error-text">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <label>Nearest Station</label>
          <div>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <input
                type="text"
                class="w-25 form-control"
                v-model="traffic.nearestStation"
              >
              <div class="error-text">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group">
          <label>Period of Use</label>
          <div>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <div class="d-flex align-items-center">
                <DateInput v-model="traffic.validityDateFrom"/>
                <div class="ml-3 mr-2">～</div>
                <DateInput v-model="traffic.validityDateTo"/>
                </div>
              <div class="error-text">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group">
          <label>Commuting Route</label>
          <div>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <textarea rows="5" class="form-control" v-model="traffic.route"></textarea>
              <div class="error-text">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </div>
      </div>
      <span v-if="traffics.length > 1"
        @click="deleteTrafficForm(traffic)"
        class="minus-container"
      >
        <font-awesome-icon class="minus" icon="times"/>
      </span>
    </form>
    <div class="plus-container">
      <span @click="createTrafficForm">
        <font-awesome-icon class="plus" icon="plus"/>
      </span>
    </div>
  </div>
</template>

<script>
import { extend, ValidationProvider } from 'vee-validate';
// eslint-disable-next-line camelcase
import { required, integer, max_value } from 'vee-validate/dist/rules';
import { mapState } from 'vuex';
import _ from 'lodash';
import DateInput from '@/components/parts/inputItem/DateInput.vue';
import SelectCampusInput from '@/components/parts/inputItem/SelectCampusInput.vue';

/* バリデーションルール */
extend('required', required);
extend('required', { message: 'required.' });
extend('integer', integer);
extend('integer', { message: 'integer.' });
extend('max_fee', max_value);
extend('max_fee', { message: 'Transportation expenses must be 99999 or less.' });
extend('max_time', max_value);
extend('max_time', { message: 'Commuting time must be 999 or less.' });

export default {
  data() {
    return {
      traffics: [],
    };
  },

  computed: {
    ...mapState({
      masterCampuses: (state) => state.master.campuses,
    }),

    originalTraffics() {
      return this.$store.getters.findTutorById(this.$route.params.id).transportationExpenses;
    },
  },

  components: {
    ValidationProvider,
    DateInput,
    SelectCampusInput,
  },

  async created() {
    if (this.$route.params?.changeTraffic) {
      this.traffics = this.$route.params.changeTraffic
      return
    }

    this.$store.dispatch('getTutor', {
      tutorId: this.$route.params.id,
    })
      .finally(() => {
        // 差分比較用として、交通費の情報をコピーして保持
        if (this.originalTraffics) {
          this.traffics = _.cloneDeep(this.originalTraffics);
        }

        // もし、データが無ければフォームをひとつ作成
        if (!this.traffics || this.traffics.length === 0) {
          this.createTrafficForm();
        }
      });
  },

  methods: {
    /* +ボタンを押されたとき、formをひとつ追加 */
    createTrafficForm() {
      this.traffics.push({});
    },

    /* ×ボタンを押されたとき、該当のformをひとつ削除 */
    deleteTrafficForm(traffic) {
      const index = this.traffics.indexOf(traffic);
      this.traffics.splice(index, 1);
    },

    /* 確認画面に遷移 */
    formConfirm() {
      // idが無い物を抜粋し、postとしてまとめる。
      const postTraffic = _.reject(this.traffics, 'transportationExpenseId');

      // 編集前後のデータを比較し、編集で消されたものをdeleteとしてまとめる。
      const deleteTraffic = _.differenceBy(
        this.originalTraffics,
        _.filter(this.traffics, 'transportationExpenseId'),
        'transportationExpenseId',
      );

      // 編集前後のデータを比較。同じIdの物をピックアップし、新しく配列を作成。
      const difference = _.intersectionBy(
        _.filter(this.traffics, 'transportationExpenseId'),
        this.originalTraffics,
        'transportationExpenseId',
      );

      // 先程作成した配列と編集前の配列を比較。更新されていないもの以外をputとしてまとめる。
      const putTraffic = _.differenceWith(
        difference,
        this.originalTraffics,
        _.isEqual,
      )

      this.$router.push(
        {
          name: 'TutorConfirmTraffic',
          params: {
            changeTraffic: this.traffics,
            post: postTraffic,
            delete: deleteTraffic,
            put: putTraffic,
          },
        },
      );
    },
  },

};
</script>

<style scoped>

.plus-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom:20px;
  padding: 0px 20px;
}

.plus {
  background: #1cc8a0;
  border: 2px solid #1cc8a0;
  width:50px;
  min-width:50px;
  height: 25px;
  color: #fff;
  border-radius: 30px;
  padding: 5px;
  transition: .2s;
}

.plus:hover {
  background: #fff;
  color: #1cc8a0;
}

span.minus-container {
  position:absolute;
  top: 20px;
  right: 20px;
}

.minus {
  color: #fff;
  border-radius: 30px;
  padding: 5px;
  background: #D84C60;
  border:2px solid #D84C60;
  width: 30px;
  height: 30px;
  transition: .2s;
}

.minus:hover {
  background: #fff;
  color: #D84C60;
}

.traffic {
  position: relative;
}

</style>
